<button mat-stroked-button class="packaging-button" (click)="openDialog()">
  <mat-icon>straighten</mat-icon>
  Packungseinheiten zuordnen
</button>
